// FUNCTIONS
async function ajaxRenderTeamMembers(filter, page) {
	try {
		const formData = new FormData();

		formData.append('action', 'ajaxRenderTeamMembers');
		formData.append('filter', filter);
		formData.append('page', page);

		const response = await fetch(adminAjax, {
			body: formData,
			method: 'POST'
		});

		if (!response.ok) {
			throw new Error('Failed to fetch team members.');
		} else {
			const message = await response.json();

			document.querySelectorAll('.meet-the-team .team-member').forEach(el => el.remove());
			document.querySelector('.meet-the-team .pagination')?.remove();

			if (filter && paginationChangeInitialized) {
				paginationChangeInitialized = false;
			}

			if (document.querySelector('.meet-the-team .pagination')) {
				document.querySelector('.pagination').insertAdjacentHTML('beforebegin', message.data);
			} else {
				document.querySelector('.meet-the-team > .container-fluid > .row .meet-intro').insertAdjacentHTML('afterend', message.data);
			}

			document.querySelectorAll('.team-member').forEach((element) => {
				fadeIn(element);
			});

			if (!paginationChangeInitialized && document.querySelector('.meet-the-team .pagination') !== null) {
				paginationChangeInitialized = true;
			}
		}
	} catch (error) {
		console.error(error);
		alert('Cannot connect to the server. Please try again later.');
	}
}

const showTeamInitial = () => {
	if (window.location.hash) {
		document.querySelector('.meet-the-team .meet-intro select option[value="' + window.location.hash.substring(1) + '"]').selected = true;
		ajaxRenderTeamMembers(window.location.hash.substring(1), 1);
	} else {
		ajaxRenderTeamMembers(false, 1);
	}
};

// VARIABLES
const desktopModalHeight = .65;
const teamMembers = document.querySelector('.meet-the-team');

// INITIALIZATION
showTeamInitial();

// EVENT LISTENERS
document.body.addEventListener('touchmove', (event) => {
	if (event.currentTarget.classList.contains('modal')) {
		event.preventDefault();
	}
});

document.querySelector('.meet-the-team .meet-intro select').addEventListener('change', (event) => {
	const filter = event.currentTarget.value;
	let hash;

	if (filter == 'all') {
		hash = window.location.pathname;
		ajaxRenderTeamMembers(false, 1);
	} else {
		hash = '#' + filter;
		ajaxRenderTeamMembers(filter, 1);
	}

	history.replaceState(undefined, undefined, hash);
});

document.querySelector('.meet-the-team .meet-intro select').addEventListener('touchstart', () => {
	touchStartPosition = event.originalEvent.touches[0].clientY;
});

document.querySelector('#meet-the-team-modal .close i').addEventListener('click', () => {
	const modal = document.getElementById('meet-the-team-modal');

	modal.style.display = 'none';
	document.body.classList.remove('modal');

	modal.querySelector('img').src = '';
	modal.querySelector('h1').textContent = '';
	modal.querySelector('h2').textContent = '';
	modal.querySelector('.bio').innerHTML = '';
});

teamMembers.addEventListener('change', (event) => {
	if (event.target.matches('.pagination select')) {
		const filter = window.location.hash.substring(1) || false;
		const page = event.target.value;

		ajaxRenderTeamMembers(filter, page);
	}
});

teamMembers.addEventListener('click', (event) => {
	const selection = event.target.closest('.team-member');

	if (selection) {
		const modal = document.getElementById('meet-the-team-modal');

		const bio = selection.querySelector('.bio').value;
		const image = selection.querySelector('.image').value;
		const name = selection.querySelector('.name').value;
		const positions = selection.querySelector('.positions').value;

		modal.querySelector('.bio').innerHTML = bio;
		modal.querySelector('h1').textContent = name;
		modal.querySelector('h2').textContent = positions;
		modal.querySelector('img').src = image;

		if (window.innerWidth >= 768) {
			const height = window.innerHeight * desktopModalHeight;
			modal.querySelector('.container-fluid .right').style.height = `${height}px`;
		} else {
			modal.querySelector('.container-fluid .right').removeProperty('height');
		}

		document.body.classList.add('modal');
		modal.style.display = 'block';
	}
});

window.addEventListener('resize', () => {
	if (document.body.classList.contains('modal')) {
		const modal = document.getElementById('meet-the-team-modal');

		if (window.innerWidth >= 768) {
			const height = window.innerHeight * desktopModalHeight;
			modal.querySelector('.container-fluid .right').style.height = `${height}px`;
		} else {
			modal.querySelector('.container-fluid .right').removeProperty('height');
		}
	}
});